// react
import { useRouter } from "next/router";
import { useEffect, useState } from "react";

// redux
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { getEleRecordList } from "~/redux/actions/user";
import { showAppModal } from "~/redux/actions/app";

// views
import SiteLayout from "~/components/layout/SiteLayout";
import Pager from "~/components/site/Pager";
import NewPostCard from "~/components/sider/NewPostCard";
import EmptyList from "~/components/app/EmptyList";
import Loading from "~/components/app/Loading";
import EleRecord from "~/components/user/EleRecord";
import { Card, Row, Col, Collapse } from "antd";
import moment from "moment";
import PostLink from "../components/post/PostLink";
import RichContent from "~/components/app/RichContent";
import QuoteContent from "~/components/app/QuoteContent";
import UserLink from "~/components/user/UserLink";

const { Panel } = Collapse;

const Page = (props) => {
  // hooks
  const router = useRouter();
  const { page = 1 } = router.query;

  // props
  const { token, eleRecordList } = props;

  const formatDate = (date) => {
    return moment(date).format("YYYY-MM-DD HH:mm");
  };

  // handles
  const handleFetch = (page) => {
    props.getEleRecordList(token, { page });
    router.push(`/ele_records?page=${page}`, { shallow: true });
  };

  const EleDetail = ({ label, detail }) => (
    <div className="flex align-items-top mt-10">
      <span className="text-secondary inline-block w-50">{label}：</span>
      <span>{detail}</span>
    </div>
  );

  // events
  useEffect(() => handleFetch(page), []);

  // views
  const pageSider = (
    <div>
      <NewPostCard />
      <Card title="电量用途">
        <ul>
          <li>查看他人的联系方式，-5；</li>
          <li>查看职位的申请方式，-5；</li>
          <li>用来赞赏和支持你喜欢的帖子和作者；</li>
          <li>用来感谢那些帮你回答了问题或者解决了问题的社区居民；</li>
          {/* <li>可以用来置顶推荐自己的帖子，电量-5/天。</li> */}
        </ul>
      </Card>

      {/* <Card
        title='电量获取'
      >
        <ul>
          <li>通过给社区搬运招聘帖获得：即在其他地方看到好的工作机会，转载搬运到社区「招聘」版块中来（每帖电量+2；每天最多1次）；</li>
          <li>通过给帖子评论来获得（每次电量+1；每天最多2次）；</li>
          <li>完善个人主页的信息也能获得电量+2。</li>
          <li>
            通过充值快速获得⬇︎
            <div className="btn-topup">
              <a
                className="ant-btn ant-btn-primary ant-btn-sm ant-btn-block"
                onClick={() => {
                  props.showAppModal("TopUpModal");
                }}
              >
                充电
              </a>
            </div>
          </li>
        </ul>
      </Card> */}

      <style jsx>
        {`
          ul {
            margin: 0;
            font-size: 14px;
            color: #9b9b9b;
            padding-inline-start: 20px;
            line-height: 24px;
          }
          .btn-topup {
            margin-top: 10px;
          }
        `}
      </style>
    </div>
  );

  return (
    <SiteLayout
      pageTitle="电量明细"
      pageSider={pageSider}
    >
      <Card>
        <h1 className="page-title">电量明细</h1>

        <div className="record-list">
          <div className="my-10 px-20">
            <Row
              type="flex"
              justify="space-between"
              gutter={8}
            >
              <Col span={10}>
                <strong>操作内容</strong>
              </Col>
              <Col span={7}>
                <strong style={{ paddingLeft: "10px" }}>操作时间</strong>
              </Col>
              <Col
                span={7}
                className="text-right"
              >
                <strong>电量值</strong>
              </Col>
            </Row>
          </div>
          <Collapse>
            {eleRecordList ? (
              eleRecordList.records.length ? (
                eleRecordList.records.map((record) => (
                  <Panel
                    header={
                      <Row
                        type="flex"
                        justify="space-between"
                        gutter={8}
                      >
                        <Col span={10}>
                          <span className="text-break">
                            {record.kind_label}
                          </span>
                        </Col>
                        <Col span={7}>
                          <span>{formatDate(record.created_at)}</span>
                        </Col>
                        <Col
                          span={7}
                          className="text-right"
                        >
                          {record.ele > 0 ? "+" : ""}
                          {record.ele}
                          <span className={record.ele > 0 ? "up" : "down"} />
                        </Col>
                      </Row>
                    }
                    key={record.id}
                  >
                    {record.details &&
                      record.details.post &&
                      record.details.post.title && (
                        <EleDetail
                          label="帖子"
                          detail={<PostLink post={record.details.post} />}
                        />
                      )}
                    {record.details && record.details.comment && (
                      <EleDetail
                        label="评论"
                        detail={
                          <QuoteContent>
                            <RichContent
                              html={record.details.comment.content}
                            />
                          </QuoteContent>
                        }
                      />
                    )}
                    {record.details && record.details.group && (
                      <EleDetail
                        label="群名"
                        detail={record.details.group.name}
                      />
                    )}
                    {record.details && record.details.category && (
                      <EleDetail
                        label="版块"
                        detail={record.details.category.name}
                      />
                    )}
                    {record.details &&
                      record.details.user &&
                      record.kind !== "post_contact_view" && (
                        <EleDetail
                          label="用户"
                          detail={<UserLink user={record.details.user} />}
                        />
                      )}
                    {record.details && record.details.reason && (
                      <EleDetail
                        label="理由"
                        detail={record.details.reason}
                      />
                    )}
                    {[
                      "user_created",
                      "user_detailed",
                      "user_upgrade",
                      "ele_charged",
                    ].includes(record.kind) && record.kind_label}
                  </Panel>
                ))
              ) : (
                <EmptyList />
              )
            ) : (
              <Loading />
            )}
          </Collapse>
        </div>

        <Pager
          pager={eleRecordList && eleRecordList.pager}
          onPageChange={handleFetch}
        />
      </Card>
      <style jsx>
        {`
          .up,
          .down {
            content: " ";
            display: inline-block;
            background-position: right center;
            background-repeat: no-repeat;
            width: 21px;
            height: 20px;
            vertical-align: text-bottom;
          }

          .up {
            background-image: url(/static/icons/arrow-up.svg);
          }

          .down {
            background-image: url(/static/icons/arrow-down.svg);
          }
        `}
      </style>
    </SiteLayout>
  );
};

const mapStateToProps = (state) => ({
  token: state.user.token,
  eleRecordList: state.user.eleRecordList,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getEleRecordList,
      showAppModal,
    },
    dispatch
  );

Page.requireUser = () => true;

export default connect(mapStateToProps, mapDispatchToProps)(Page);
